import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { NavigationForm } from '@/components/forms/NavigationForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateNavigationPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/system-settings/navigation', { state: { showReloginModal: true } })
  }

  const handleCancel = () => {
    navigate('/system-settings/navigation')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Navigation</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new navigation item and add it to this site.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <NavigationForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


